module.exports = __webpack_public_path__ + "static/media/hit-logo.dc6f30bc.svg";